// ═══════════════════════════════════════════════════════════════════
// keeperPortrait3D.jsx — ANY PLAZA BEING, STANDING IN A DOM BOX
// ═══════════════════════════════════════════════════════════════════
// caP'n, 2026-09-23: "when all characters are spoken to from now on, I
// want this style of menu, where the character model is here … let's
// finally get rid of this placeholder."
//
// VaelPortrait3D's pattern (one transparent canvas the size of its box),
// generalised to every body plazaFolk3D knows. It draws FolkBody, so the
// SAME model the Plaza walks around — the Law of One Body — and FolkBody
// already carries each being's painted fail-safe, so nothing goes blank
// while a .glb loads or if it fails.
//
// FRAMING is per being because the bodies are not the same shape: V'yen
// is a 2.2 m lamia whose coil arches rise to 2.7 m, the rest are people.
//   ty   — the height the lens aims at (m)
//   dist — how far back it stands (m)
//   el   — how far above the aim point it sits (m)
// A being with no row gets a framing worked out from its height.
//
// `ctl.player` is a fake "you" a few tiles in front of the body, so a
// being that turns to its customer (V'yen) turns to the camera.
// PERF LAW: nothing here sets React state from a frame.
// ═══════════════════════════════════════════════════════════════════
import { Suspense, useRef } from "react";
import { Canvas } from "@react-three/fiber";
import * as THREE from "three";
import { FolkBody, folkHeight } from "./plazaFolk3D";

const FRAMING = {
  vyen: { ty: 1.55, dist: 4.6, el: 0.25, fov: 30 },
};
const framingFor = (id) => {
  if (FRAMING[id]) return FRAMING[id];
  const h = folkHeight(id);
  return { ty: h * 0.54, dist: h * 3.3, el: h * 0.06, fov: 24 };
};

// `acting` (2026-09-25): extra ctl fields for a body that can act — Willie reads
// expr / talk / act / hands / book / hold (willieActing.js). Bodies that don't, ignore them.
const ACT_KEYS = ["expr", "talk", "act", "hands", "book", "hold", "look", "point"];
export default function KeeperPortrait3D({ id, facing = { x: 0, y: 1 }, style, acting = null }) {
  // the customer, in Plaza tiles (a tile's centre is +0.5): 3 m in front of the body
  const player = useRef({ x: -0.5, y: 2.5 });
  const ctl = useRef({ facing, speed: 0, player }).current;
  ctl.facing = facing;
  for (const k of ACT_KEYS) ctl[k] = acting ? acting[k] : undefined;
  const f = framingFor(id);
  return (
    <Canvas
      dpr={[1, 1.5]}
      gl={{ alpha: true, antialias: true, powerPreference: "low-power", toneMapping: THREE.ACESFilmicToneMapping }}
      camera={{ position: [0, f.ty + f.el, f.dist], fov: f.fov, near: 0.1, far: 40 }}
      onCreated={(s) => { s.gl.setClearColor(0x000000, 0); s.camera.lookAt(0, f.ty, 0); }}
      style={{ width: "100%", height: "100%", background: "transparent", pointerEvents: "none", ...style }}
    >
      <ambientLight intensity={0.35} color="#b8a8e0" />
      <hemisphereLight args={["#fff4ee", "#4a3a58", 1.1]} />
      <directionalLight position={[1.5, 3, 4]} intensity={1.6} color="#fff0e0" />
      <directionalLight position={[-3, 2, -2]} intensity={0.7} color="#ff8a6a" />
      <Suspense fallback={null}>
        <FolkBody id={id} ctl={ctl} />
      </Suspense>
    </Canvas>
  );
}
